// let member_platform_config = "http://localhost:8090";
let member_platform_config = "https://myd0755.com/seller-front";

export default member_platform_config